import React, { useState } from "react";
import axios from "axios";
import "./CSS/LoginSignup.css";

const LoginSignup = () => {

  const [state,setState] = useState("Login");
  const [formData,setFormData] = useState({username:"",email:"",password:""});

  const changeHandler = (e) => {
    setFormData({...formData,[e.target.name]:e.target.value});
    }

  const login = async () => {
    try {
      const response = await axios.post('https://shopper-e-commerce-project-xi55.vercel.app/login', formData);
      const dataObj = response.data;
      if (dataObj.success) {
        localStorage.setItem('auth-token', dataObj.token);
        window.location.replace("/");
      } else {
        alert(dataObj.errors);
      }
    } catch (error) {
       alert(error.response?.data?.errors || "Error logging in");
    }
  };

  const signup = async () => {
    try {
      const response = await axios.post('https://shopper-e-commerce-project-xi55.vercel.app/signup', formData);
      const dataObj = response.data;
      if (dataObj.success) {
        localStorage.setItem('auth-token', dataObj.token);
        window.location.replace("/");
      } else {
        alert(dataObj.errors);
      }
    } catch (error) {
       alert(error.response?.data?.errors || "Error signing up");
    }
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
          {state==="Sign Up"?<input type="text" placeholder="Your name" name="username" value={formData.username} onChange={changeHandler}/>:<></>}
          <input type="email" placeholder="Email address" name="email" value={formData.email} onChange={changeHandler}/>
          <input type="password" placeholder="Password" name="password" value={formData.password} onChange={changeHandler}/>
        </div>

        <button onClick={()=>{state==="Login"?login():signup()}}>Continue</button>

        {state==="Login"?
        <p className="loginsignup-login">Create an account? <span onClick={()=>{setState("Sign Up")}}>Click here</span></p>
        :<p className="loginsignup-login">Already have an account? <span onClick={()=>{setState("Login")}}>Login here</span></p>}

        <div className="loginsignup-agree">
          <input type="checkbox" name="" id="" />
          <p>By continuing, i agree to the terms of use & privacy policy.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;
